import { render } from "./TournamentCard.vue?vue&type=template&id=547daedb&ts=true"
import script from "./TournamentCard.vue?vue&type=script&lang=ts"
export * from "./TournamentCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__